import React from 'react';
import { motion } from 'motion/react';

export default function FiveMinuteRewindCover() {
  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden select-none bg-slate-900 font-sans shadow-inner">
      {/* Background: Cozy Vintage Bookstore / Thrift Store */}
      <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-[#1E112A] via-[#101026] to-[#0A0B1A]">
        {/* Magic Dust Glow */}
        <div className="absolute left-[30%] top-[20%] w-[50%] h-[50%] rounded-full bg-amber-500/10 blur-[60px]" />
        <div className="absolute right-[10%] top-[40%] w-[40%] h-[40%] rounded-full bg-indigo-500/10 blur-[50px]" />

        {/* Floating Sparks/Magic Dust */}
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(8)].map((_, i) => (
            <motion.div
              key={`spark-${i}`}
              className="absolute w-1 h-1 rounded-full bg-amber-300"
              style={{
                left: `${20 + Math.random() * 60}%`,
                top: `${30 + Math.random() * 50}%`,
                opacity: 0.3 + Math.random() * 0.7,
              }}
              animate={{
                y: [0, -40 - Math.random() * 40],
                x: [0, (Math.random() - 0.5) * 30],
                opacity: [0, 0.9, 0],
                scale: [0.8, 1.5, 0.5],
              }}
              transition={{
                duration: 3 + Math.random() * 3,
                repeat: Infinity,
                delay: Math.random() * 2,
                ease: "easeInOut",
              }}
            />
          ))}
        </div>

        {/* Left Side: Bookshelves in perspective */}
        <div className="absolute left-[-5%] top-[15%] w-[32%] h-[80%] opacity-40 z-10">
          <svg viewBox="0 0 100 200" className="w-full h-full text-amber-900/40 fill-current">
            {/* Shelf Structure */}
            <line x1="10" y1="10" x2="90" y2="30" stroke="#4a2511" strokeWidth="6" />
            <line x1="10" y1="70" x2="90" y2="90" stroke="#4a2511" strokeWidth="6" />
            <line x1="10" y1="130" x2="90" y2="150" stroke="#4a2511" strokeWidth="6" />
            
            {/* Books on Shelves */}
            <rect x="15" y="32" width="10" height="35" rx="1" fill="#c026d3" />
            <rect x="27" y="35" width="12" height="32" rx="1" fill="#ea580c" />
            <rect x="41" y="42" width="8" height="25" rx="1" fill="#0284c7" />
            <rect x="51" y="38" width="11" height="30" rx="1" fill="#16a34a" />
            
            <rect x="15" y="92" width="14" height="35" rx="1" fill="#ca8a04" />
            <rect x="31" y="98" width="9" height="29" rx="1" fill="#dc2626" />
            <rect x="42" y="94" width="13" height="33" rx="1" fill="#4f46e5" />
          </svg>
        </div>

        {/* Right Side: Clothes racks in perspective */}
        <div className="absolute right-[-5%] top-[15%] w-[32%] h-[80%] opacity-40 z-10">
          <svg viewBox="0 0 100 200" className="w-full h-full text-amber-900/40 fill-current">
            {/* Rack Bar */}
            <line x1="10" y1="30" x2="90" y2="10" stroke="#4b5563" strokeWidth="4" />
            
            {/* Hanging Clothes */}
            <path d="M 20 28 L 30 25 L 30 110 L 15 110 L 15 40 Z" fill="#b91c1c" />
            <path d="M 35 25 L 45 22 L 45 105 L 32 105 L 32 35 Z" fill="#0e7490" />
            <path d="M 50 20 L 60 18 L 60 115 L 47 115 L 47 30 Z" fill="#e11d48" />
            <path d="M 65 16 L 75 14 L 75 100 L 62 100 L 62 25 Z" fill="#d97706" />
          </svg>
        </div>

        {/* Center Character: Curious Boy with Brown Hair & Teal Striped Shirt */}
        <div className="absolute inset-x-0 bottom-0 h-[65%] z-15 flex justify-center items-end">
          <div className="relative w-48 h-full">
            <svg viewBox="0 0 100 100" className="absolute bottom-[-2px] w-full h-full fill-current">
              {/* Torso: Teal Striped Shirt */}
              <path d="M 30 100 L 70 100 L 66 75 C 64 68 58 64 50 64 C 42 64 36 68 34 75 Z" fill="#0f766e" />
              {/* Stripes on shirt */}
              <path d="M 32 82 Q 50 81 68 82 L 67 87 Q 50 86 33 87 Z" fill="#93c5fd" />
              <path d="M 31 92 Q 50 91 69 92 L 69 96 Q 50 95 31 96 Z" fill="#ffffff" />

              {/* Red-ish backpack straps */}
              <path d="M 34 75 Q 40 78 40 100" stroke="#be123c" strokeWidth="4" fill="none" />
              <path d="M 66 75 Q 60 78 60 100" stroke="#be123c" strokeWidth="4" fill="none" />

              {/* Neck */}
              <rect x="46" y="56" width="8" height="10" fill="#fbcfe8" /> {/* warm clean pale pink skin tones */}
              
              {/* Head / Ears */}
              <ellipse cx="50" cy="46" rx="14" ry="14" fill="#fbcfe8" />
              <circle cx="35" cy="46" r="3.5" fill="#fbcfe8" />
              <circle cx="65" cy="46" r="3.5" fill="#fbcfe8" />

              {/* Eyes - Wide with wonder */}
              <circle cx="44" cy="44" r="3.5" fill="#ffffff" />
              <circle cx="45" cy="44" r="1.8" fill="#5c3a21" /> {/* brown eyes */}
              
              <circle cx="56" cy="44" r="3.5" fill="#ffffff" />
              <circle cx="55" cy="44" r="1.8" fill="#5c3a21" />

              {/* Little nose and mouth with slight wonder */}
              <path d="M 49 46 Q 50 48 51 46" stroke="#e11d48" strokeWidth="1.2" fill="none" />
              <ellipse cx="50" cy="51" rx="1.5" ry="0.8" fill="#881337" />

              {/* Cheeks blush */}
              <circle cx="40" cy="48" r="2" fill="#fda4af" opacity="0.6" />
              <circle cx="60" cy="48" r="2" fill="#fda4af" opacity="0.6" />

              {/* Messy Boy Hair (Rich Brown) */}
              <path d="M 32 46 C 30 38 34 26 50 26 C 66 26 70 38 68 46 C 71 42 70 32 60 28 C 50 24 45 27 38 29 C 30 31 29 42 32 46 Z" fill="#451a03" />
              {/* Extra bangs */}
              <path d="M 38 31 Q 42 36 45 34 C 47 32 46 29 44 29 Z" fill="#451a03" />
              <path d="M 45 31 Q 50 38 52 35 C 55 31 51 28 48 29 Z" fill="#451a03" />
              <path d="M 52 32 Q 56 36 59 33 C 61 31 58 28 55 29 Z" fill="#451a03" />
            </svg>
          </div>
        </div>

        {/* Vintage Silver Pocket Watch - Raised on left-center */}
        <div className="absolute left-[8%] sm:left-[12%] top-[34%] w-[38%] h-[38%] z-20 flex items-center justify-center">
          <motion.div 
            className="relative w-24 h-24 flex items-center justify-center filter drop-shadow-[0_8px_16px_rgba(0,0,0,0.7)] cursor-pointer"
            animate={{
              y: [0, -3, 0],
              rotate: [0, 1.5, -1.5, 0]
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            whileHover={{ scale: 1.1 }}
          >
            {/* Hanging Ring on Top */}
            <div className="absolute top-0 w-6 h-6 rounded-full border-[3px] border-slate-300 bg-transparent flex items-end justify-center">
              <div className="w-1.5 h-3 bg-slate-300" />
            </div>

            {/* Brass Outer Case */}
            <div className="mt-4 w-20 h-20 rounded-full bg-gradient-to-br from-slate-200 via-slate-400 to-slate-500 p-1 border-2 border-slate-300 shadow-inner flex items-center justify-center">
              {/* Inner Dial Face */}
              <div className="w-full h-full rounded-full bg-amber-50 relative flex items-center justify-center border border-slate-400 shadow-[inset_0_2px_6px_rgba(0,0,0,0.3)]">
                
                {/* Watch tick markings */}
                {[...Array(8)].map((_, tick) => (
                  <div
                    key={`tick-${tick}`}
                    className="absolute w-1 h-1.5 bg-slate-700/60"
                    style={{
                      transform: `rotate(${tick * 45}deg) translateY(-32px)`,
                    }}
                  />
                ))}

                {/* Big dial number 5 in gold representing five minutes */}
                <span className="absolute bottom-[10%] text-[9px] font-bold font-mono text-amber-700">5</span>

                {/* Arrow Pointer Hand - Animated to slightly tick! */}
                <motion.div 
                  className="absolute bottom-1/2 left-1/2 w-[2px] h-[30px] bg-slate-800 origin-bottom transform -translate-x-1/2 rounded-full"
                  animate={{
                    rotate: [30, 31, 30, 35, 30]
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                
                {/* Vintage Pocket-watch text line */}
                <span className="absolute top-[20%] text-[6px] font-sans font-medium tracking-wide text-slate-500 uppercase scale-75">Rewind</span>

                {/* Center screw */}
                <div className="w-2 h-2 rounded-full bg-amber-800 border border-slate-300" />
              </div>
            </div>

            {/* Golden Magic Ripple Ring */}
            <motion.div 
              className="absolute inset-0 rounded-full border-2 border-amber-400/50 pointer-events-none"
              animate={{
                scale: [0.8, 1.5],
                opacity: [1, 0]
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeOut"
              }}
            />
          </motion.div>
        </div>
      </div>

      {/* TITLE OVERLAY: Creative Bubble Typography */}
      <div className="absolute inset-0 flex flex-col items-center justify-between p-7 text-center z-35 pointer-events-none">
        
        {/* Playful Header */}
        <div className="w-full flex flex-col items-center mt-2">
          {/* "THE" tag */}
          <span className="text-amber-300 font-sans font-bold text-[10px] sm:text-xs tracking-[0.25em] uppercase drop-shadow-[0_2px_4px_rgba(0,0,0,0.85)] mb-1">
            THE
          </span>
          
          {/* Main Title Bubble-style Block */}
          <h1 
            className="font-sans font-black text-xl sm:text-2xl md:text-3.2xl text-transparent bg-clip-text bg-gradient-to-b from-white via-amber-100 to-amber-200 tracking-tight leading-none uppercase drop-shadow-[0_4px_8px_rgba(0,0,0,1)] select-none font-bold"
            style={{
              textShadow: '0 3px 6px rgba(124, 45, 18, 0.9), 0 0 15px rgba(245, 158, 11, 0.4)',
              WebkitTextStroke: '0.5px rgba(120, 53, 4, 0.4)'
            }}
          >
            FIVE-MINUTE<br />
            <span className="text-amber-400 bg-clip-text">REWIND</span>
          </h1>
        </div>

        {/* Bottom Author block */}
        <div className="mb-2">
          <span 
            className="text-white font-mono text-[9px] sm:text-[11px] font-bold tracking-[0.16em] uppercase opacity-95 drop-shadow-[0_2px_5px_rgba(0,0,0,0.95)]"
          >
            By Cian Zaki
          </span>
        </div>
      </div>

      {/* Atmospheric Vignette overlay */}
      <div className="absolute inset-0 pointer-events-none bg-radial-vignette opacity-50 mix-blend-multiply z-25" />
    </div>
  );
}
